import Button from '../../../../../components/Assets/Button';
import styles from './loginChoiceButton.module.scss';

const SIGNUP_URL = process.env.REACT_APP_SIGNUP_URL;
interface ISignChoiceButtonProps {
  className: string;
}
function SignChoiceButton({ className }: ISignChoiceButtonProps) {
  const handleButtonClick = () => {
    window.open(SIGNUP_URL);
  };
  return (
    <div className={className}>
      <div className={styles.signChoiceButton}>
        <p>Pas encore client</p>

        <Button
          btnType="button"
          btnContent="CREEZ UN COMPTE"
          handleClick={handleButtonClick}
          primary
        />
      </div>
    </div>
  );
}

export default SignChoiceButton;
